export default "__VITE_ASSET__BNT3P3iS__"